import { useState, useRef, useEffect } from "react";
import { ChevronDown, Globe } from "lucide-react";
import { useI18n, LANGS } from "@/lib/i18n";

export default function LanguageSwitcher({ light = false }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  useEffect(() => {
    const fn = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("click", fn);
    return () => document.removeEventListener("click", fn);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        data-testid="lang-switcher-btn"
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-sm transition-colors ${
          light ? "hover:bg-white/10" : "hover:bg-brand-secondary/50"
        }`}
        aria-label="Language"
      >
        <Globe size={14} />
        <span className="uppercase tracking-wider text-xs">{current.code}</span>
        <ChevronDown size={12} />
      </button>
      {open && (
        <div data-testid="lang-switcher-menu" className="absolute right-0 mt-2 w-44 bg-white border border-brand-border rounded-sm shadow-lg overflow-hidden z-50">
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-3 hover:bg-brand-bg ${l.code === lang ? "text-brand-primary font-medium" : "text-brand-text"}`}
            >
              <span className="text-base">{l.flag}</span> {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
